import apiClient from './client';
import { ApiResponse, CCTV, PaginatedResponse, PaginationParams } from '@/types';

export const cctvApi = {
  getAll: (params?: PaginationParams & { clientId?: string; status?: string }) =>
    apiClient.get<PaginatedResponse<CCTV>>('/cctv', { params }),

  getById: (id: string) =>
    apiClient.get<ApiResponse<CCTV>>(`/cctv/${id}`),

  create: (data: Partial<CCTV>) =>
    apiClient.post<ApiResponse<CCTV>>('/cctv', data),

  update: (id: string, data: Partial<CCTV>) =>
    apiClient.put<ApiResponse<CCTV>>(`/cctv/${id}`, data),

  remove: (id: string) =>
    apiClient.delete<ApiResponse<void>>(`/cctv/${id}`),
};
